<template>
  <v-app-bar
    :fixed="false"
    :hide-on-scroll="true"
    density="compact"
    app
    color="primary"
    dark
    class="px-3"
    v-if="$route && $route.name !== 'Login'"
  >
    <v-toolbar-title class="pl-1 d-flex align-center">
      <v-btn
        @click="toggleSideBar"
        color="primary"
        elevation="0"
        class="gradient-background left-nav-btn mr-2"
        size="large"
      >
        <v-icon color="white" size="xx-large"> mdi-reorder-horizontal </v-icon>
      </v-btn>
      <v-btn
        class="gradient-background left-nav-btn"
        color="primary"
        elevation="0"
        @click="$router.push('/')"
        size="large"
      >
        <v-icon color="white" size="xx-large"> mdi-gamma </v-icon>
      </v-btn>
    </v-toolbar-title>

    <v-spacer> </v-spacer>

    <div class="d-flex align-center">
      <v-btn
        size="small"
        v-if="!userIsEstablishmentAdmin"
        class="mx-1 nav-button-crop"
        elevation="0"
        color="rgba(37, 2, 106, 0.9)"
        @click="navToCostItems"
      >
        <v-icon color="white" size="x-large"> mdi-crop </v-icon>
      </v-btn>
      <v-btn
        size="small"
        v-if="!userIsEstablishmentAdmin"
        class="mx-1 nav-button-weight"
        elevation="0"
        color="rgba(25, 118, 210, 0.9)"
        @click="navToOtherTonCostItems"
      >
        <v-icon color="white" size="x-large"> mdi-weight </v-icon>
      </v-btn>
      <v-btn
        size="small"
        class="mx-1 nav-button-save"
        elevation="0"
        color="transparent"
        disabled
      >
        <v-icon color="white" size="x-large"> mdi-content-save-cog </v-icon>
      </v-btn>
      <v-btn
        size="small"
        class="mx-1 nav-button-network"
        elevation="0"
        color="transparent"
        disabled
      >
        <v-icon color="white" size="x-large"> mdi-access-point-network </v-icon>
      </v-btn>
      <v-btn
        size="small"
        v-if="userIsAdmin"
        class="mx-1 nav-button-admin"
        elevation="0"
        color="transparent"
        @click="goToUserPanel"
      >
        <v-icon color="white" size="x-large"> mdi-account-supervisor</v-icon>
      </v-btn>
      <v-btn
        size="small"
        class="mx-1 nav-button-profile"
        elevation="0"
        color="transparent"
        @click="goToUserProfile"
      >
        <v-icon color="white" size="x-large">
          mdi-account-circle-outline
        </v-icon>
      </v-btn>
      <v-btn
        size="small"
        class="mx-1 nav-button-logout"
        elevation="0"
        color="transparent"
        @click="sendLogout"
      >
        <v-icon color="white" size="x-large"> mdi-logout </v-icon>
      </v-btn>
    </div>
  </v-app-bar>
</template>

<style scoped>
.gradient-background:hover {
  background: rgb(37, 2, 106);
  background: linear-gradient(
    326deg,
    rgba(37, 2, 106, 1) 2%,
    rgba(33, 150, 243, 1) 67%
  );
}

.left-nav-btn {
  min-width: 60px !important;
  width: 60px !important;
  height: 40px !important;
  padding: 0 !important;
  border-radius: 6px !important;
  display: inline-flex !important;
}

.nav-button-crop,
.nav-button-weight,
.nav-button-save,
.nav-button-network,
.nav-button-admin,
.nav-button-profile,
.nav-button-logout {
  min-width: 50px !important;
  width: 50px !important;
  height: 36px !important;
  border-radius: 6px !important;
  padding: 0 !important;
  display: flex;
  align-items: center;
  justify-content: center;
}

.nav-button-crop {
  background-color: rgba(37, 2, 106, 0.9) !important;
}

.nav-button-crop:hover {
  background-color: rgba(37, 2, 106, 0.7) !important;
}

.nav-button-weight {
  background-color: rgba(25, 118, 210, 0.9) !important;
}

.nav-button-weight:hover {
  background-color: rgba(25, 118, 210, 0.7) !important;
}

.nav-button-save:hover {
  background-color: rgba(255, 193, 7, 1) !important; /* accent - amber */
}

.nav-button-network:hover {
  background-color: rgba(3, 169, 244, 1) !important; /* info - light blue */
}

.nav-button-admin:hover {
  background-color: rgba(37, 2, 106, 1) !important; /* primary - deep purple */
}

.nav-button-profile:hover,
.nav-button-logout:hover {
  background-color: rgba(76, 175, 80, 1) !important; /* secondary - green */
}

.v-btn--disabled:hover {
  background-color: rgba(100, 100, 100, 0.3) !important;
}
</style>

<script>
import { computed } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import { logout } from "../../managrx/AutAndAuthServices";
import { ESTABLISHMENT_ADMIN_ROLE } from "../../managrx/userRoles";

export default {
  name: "TopBar",
  setup() {
    const store = useStore();
    const router = useRouter();

    // Get reactive state from store
    const userIsAdmin = computed(() => {
      return store.state.userTokenInfo?.utype === "admin";
    });

    const userIsEstablishmentAdmin = computed(() => {
      return store.state.userTokenInfo?.utype === ESTABLISHMENT_ADMIN_ROLE;
    });

    // Methods
    const toggleSideBar = () => {
      store.commit("TOGGLE_SIDEBAR_DRAWER");
    };

    const sendLogout = () => {
      logout();
      store.dispatch("unsetUserTokenInfo");
      router.go();
    };

    const navToCostItems = () => {
      router.push({ name: "CostItems" });
    };

    const goToLogin = () => {
      router.push({ name: "Login" });
    };

    const goToUserProfile = () => {
      router.push({ name: "UserProfile" });
    };

    const goToUserPanel = () => {
      router.push({ name: "UsersPanel" });
    };

    const navToOtherTonCostItems = () => {
      router.push({ name: "OtherTonCostItems" });
    };

    return {
      userIsAdmin,
      userIsEstablishmentAdmin,
      toggleSideBar,
      sendLogout,
      navToCostItems,
      goToLogin,
      goToUserProfile,
      goToUserPanel,
      navToOtherTonCostItems,
    };
  },
  data: () => ({
    drawer: false,
    items: ["Campana 1 - V1", "Campana 1 - V2"],
  }),
};
</script>
